import { Button, Flex, FormControl, FormLabel, Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilesList } from "components/elements/DocumentsUpload";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { ACCEPTED_FILE_TYPES } from "utils/constants";

interface ItemDocumentsProps {
  item: any;
  documents: any[];
  setDocuments: (documents: any[]) => void;
}

const ItemDocuments = ({ documents, setDocuments, item }: ItemDocumentsProps) => {
  const onDrop = useCallback(
    (acceptedFiles: any[]) => setDocuments(acceptedFiles.concat(documents)),
    [documents]
  );

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop,
    accept: ACCEPTED_FILE_TYPES,
    noClick: true,
  });

  return (
    <FormControl mb="20px">
      <FormLabel>Attached Documents</FormLabel>
      <FilesList files={documents} setFiles={setDocuments} item={item} />
      <div {...getRootProps()}>
        <Flex justifyContent="space-between">
          <Text fontSize="14px" color="gray.600" mb="8px">
            Accepted file types: .pdf, .jpg, .png, Excel, Word Document
          </Text>
          <Text fontSize="14px" color="gray.600" mb="8px">
            Maximum file size: 500 MB
          </Text>
        </Flex>
        <input {...getInputProps()} />
        <Button
          variant="ghost"
          color="primary"
          size="sm"
          pl="0px"
          onClick={e => {
            e.stopPropagation();
            open();
          }}
          leftIcon={<FontAwesomeIcon icon={["far", "plus"]} />}
        >
          {isDragActive ? "Drop" : "Upload"} files
        </Button>
      </div>
    </FormControl>
  );
};

export default ItemDocuments;
